module.exports = __webpack_public_path__ + "img/memberIcon.b25d4ed2.svg";